import { createSlice } from "@reduxjs/toolkit";
import { updateViewMenuFields } from "./viewMenuFieldsSlice";
import { altimSetTemplateViewMenu } from "../components/AltimSetTemplate";
const initialState = {
    metars: {},
    altimAirportList: [],
    metarAirportList: [],
};
export const weatherSlice = createSlice({
    name: "weather",
    initialState,
    reducers: {
        setMetars(state, action) {
            state.metars = action.payload;
        },
        setAltimeterList(state, action) {
            state.altimAirportList = action.payload;
        },
        setMetarList(state, action) {
            state.metarAirportList = action.payload;
        },
    },
});
export const weatherReducer = weatherSlice.reducer;
export const { setMetars, setMetarList } = weatherSlice.actions;
export function setAltimeterList(altimList) {
    return (dispatch) => {
        dispatch(weatherSlice.actions.setAltimeterList(altimList));
        dispatch(updateViewMenuFields(altimSetTemplateViewMenu, "draftState", altimList));
    };
}
//# sourceMappingURL=weatherSlice.js.map